import React from 'react';
import { useSelector } from 'react-redux';
import ImageViewer from './ImageViewer';
import { OVERLAY_PANEL_GAP } from '../../pages/Shoreline/theme';

const LoadedImagesAccordion = () => {
  const images = useSelector((state) => state.imagery.images);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: OVERLAY_PANEL_GAP,
        width: '100%',
      }}>
      {Object.keys(images)
        .reverse()
        .map((id, i) => {
          return <ImageViewer key={id} index={id} image={images[id]} />;
        })}
    </div>
  );
};

export default LoadedImagesAccordion;
